import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";


// API
import { api_GET, api_POST } from "../../../services/api_service";

//Helpers
import { showMessage } from "../../../services/message";

//Views
import Declaracao from "../../../views/Shared/Declaracao";
import Documentos from "../../../views/Shared/Documentos";
import CaracterizacaoResiduos from "../../../views/Shared/Gerador/CaracterizacaoResiduos";
import Residuos from "../../../views/Shared/Gerador/Residuos";
import LocaisColeta from "../../../views/Shared/Gerador/LocaisColeta";
import Identificacao from "../../../views/Shared/Gerador/Identificacao";


// reactstrap components
import { Card, CardBody, Row, Col, Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

//Context
import { useAuth } from "../../../context/auth";
import RequerimentoAvisoCard from '../components/RequerimentoAvisoCard';

export default function RequerimentoAlteracaoCadastro({ history }) {
    const { session, setLoading, setupSistema } = useAuth();

    const location = useLocation();

    const [requerimento, set_requerimento] = useState(null);

    // State para pega a opção do cadastro
    const [opcao, set_opcao] = useState(null);

    // State para definir o passa a passa do formulário
    const [steps, setSteps] = useState([]);

    const [step, set_step] = useState(0);
    const handleProximoStep = (_requerimento) => {
        set_requerimento(_requerimento);
        set_step(step + 1);
    }

    const handleStepAnterior = (_requerimento) => {
        set_requerimento(_requerimento)
        set_step(step - 1);
    }

    const loadRequerimento = () => {
        if (location.state.requerimento == null) {
            setLoading(true);
            let json_submit = {
                protocolo_Id: location.state.protocolo.protocolo_Id,
                requerimento_Id: 0,
                nomeSolicitante: location.state.protocolo.nomeSolicitante,
                email: location.state.protocolo.email,
                cpf_Cnpj: location.state.protocolo.cpf_Cnpj,
                setupSolicitacaoAcao_Id: location.state.setupSolicitacaoAcao.setupSolicitacaoAcao_Id,
            }

            api_POST('requerimento/PostRequerimento', json_submit)
                .then(result => {
                    set_opcao({
                        tipoCadastro: "Requerimento",
                        segmento: "Grande Gerador",
                        categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                    });

                    if (result.data.setupSolicitacaoAcao.setupSolicitacao.categoria.sigla != "RGG") {
                        setSteps(['Identificação', 'Locais de Coleta', 'Resíduos', 'Documentação']);
                    } else {
                        setSteps(['Identificação', 'Locais de Coleta', 'Caracterização dos Residuos', 'Documentação']);
                    }
                    set_requerimento(result.data);
                    set_step(0);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_GET('requerimento/' + location.state.requerimento.requerimento_Id)
                .then(result => {
                    set_opcao({
                        tipoCadastro: "Requerimento",
                        segmento: "Grande Gerador",
                        categoria: result.data.setupSolicitacaoAcao.setupSolicitacao.categoria
                    });
                    set_requerimento(result.data);
                    set_step(0);
                })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        loadRequerimento();
    }, []);

    return (
        <>
            {requerimento != null && opcao != null &&
                <div className="content">
                    <Container className="text-center">
                        <ProgressBar stepValue={step} steps={steps} />
                    </Container>
                    {requerimento.status == "Divergente" && requerimento.requerimentoAnaliseGestor.length > 0 &&
                        <Card className="card-stats">
                            <CardBody>
                                <h5 className="text-danger">Seu requerimento foi rejeitado por {setupSistema?.identificacao}. Verifique as informações abaixo e corrija os dados necessários.</h5>
                                <p>{requerimento.requerimentoAnaliseGestor.sort(function (a, b) { return new Date(b.dataAnalise) - new Date(a.dataAnalise); })[0].observacao}</p>
                            </CardBody>
                        </Card>
                    }

                    {step == 0 &&
                        <>
                            <RequerimentoAvisoCard />
                            <Identificacao
                                item={requerimento}
                                opcao={opcao}
                                handleProximoStep={handleProximoStep}
                            />
                        </>
                    }

                    {step == 1 &&
                        <LocaisColeta
                            item={requerimento}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }

                    {step == 2 && opcao.categoria.sigla != "RGG" &&
                        <Residuos
                            item={requerimento}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }

                    {step == 2 && opcao.categoria.sigla == "RGG" &&
                        <CaracterizacaoResiduos
                            item={requerimento}
                            opcao={opcao}
                            tipoCadastro="Requerimento"
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }

                    {step == 3 &&
                        <Documentos
                            item={requerimento}
                            opcao={opcao}
                            handleProximoStep={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }

                    {step == 4 &&
                        <Declaracao
                            item={requerimento}
                            handleFinalizarCadastro={handleProximoStep}
                            handleStepAnterior={handleStepAnterior}
                        />
                    }
                </div>
            }

            {requerimento != null && opcao != null && step == 5 &&
                <Container style={{ maxWidth: "1000px", margin: "20px auto" }}>
                    <div className="formPrincipal">
                        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, .5)", paddingBottom: "10px", paddingTop: "10px" }}>
                            <Col md="12">
                                <span className={`${session && session.tipoAcesso == "AreaRestrita" ? "text-white" : "text-black"}`}>Este requerimento já foi finalizado. Para visualizar e acompanhar as informações do requerimento, acesse o menu "Meu Cadastro".</span>
                            </Col>
                        </Row>
                    </div>
                </Container>
            }
        </>
    );
}